module.exports = __webpack_public_path__ + "static/media/dayviewSimpleWidgets.9f627a7b.png";